import styled from 'styled-components'

const HR = styled('hr')`
  border: 0;
  height: 1px;
  background: ${props => props.theme.colors.slate.lightest};
`

export default HR